<template>
	<div class="content-wrap">
		<template>
			<a-form-model
				layout="inline"
				:label-col="{ span: 8 }"
				:wrapper-col="{ span: 16 }"
				class="customer-list-form"
				:colon="false"
			>
				<a-form-model-item :label="$t('businessDispatch.customerName')">
					<a-auto-complete
						v-model.trim="params.condition.name"
						:placeholder="$t('businessDispatch.customerName')"
						:allowClear="true"
						:data-source="dataSourceName"
						@change="onChangeDataSource"
						size="small"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('customerList.address')">
					<a-auto-complete
						v-model.trim="params.condition.address"
						:placeholder="$t('customerList.address')"
						:allowClear="true"
						:data-source="dataSourceAddress"
						@change="onChangeDataSource"
						size="small"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('customerList.contactName')">
					<a-auto-complete
						v-model.trim="params.condition.customerContactName"
						:placeholder="$t('customerList.contactName')"
						:allowClear="true"
						:data-source="dataSourceContactName"
						@change="onChangeDataSource"
						size="small"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('customerList.contactNumber')">
					<a-auto-complete
						v-model.trim="params.condition.customerContactPhone"
						:placeholder="$t('customerList.contactNumber')"
						:allowClear="true"
						:data-source="dataSourceContactPhone"
						@change="onChangeDataSource"
						size="small"
					/>
				</a-form-model-item>
				<a-form-model-item>
					<a-button
						type="primary"
						@click="search"
						size="small"
						style="marginLeft:10px;"
					>
					{{ $t('search') }}
					</a-button>
				</a-form-model-item>
				<a-form-model-item>
					<a-button @click="resetCustomerList" size="small">
						{{ $t('reset') }}
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</template>


		<a-modal
			:title="isAdd ? $t('customerList.addCustomerInfo') : $t('customerList.updateCustomerInfo')"
			:visible="visible_formModal"
			@cancel="canceldriverform"
		>
			<a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
				<a-form-item :label="$t('businessDispatch.customerName')">
					<a-input
						allowClear
						v-model.trim="addReqParams.name"
						style="width: 200px"
						:placeholder="$t('businessDispatch.customerName')"
						:maxLength="50"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('businessDispatch.customerName') }],
							},
						]"
					>
					</a-input>
				</a-form-item>
				<a-form-item :label="$t('customerList.address')">
					<a-textarea
						style="width: 200px"
						allow-clear
						v-model.trim="addReqParams.address"
						:placeholder="$t('customerList.address')"
						:maxLength="250"
						:auto-size="{ minRows: 2, maxRows: 6 }"
						class="location-textarea"
					>
					</a-textarea>
				</a-form-item>
				<a-form-item :label="$t('customerList.contactPerson')">
					<a-input
						allowClear
						v-model.trim="addReqParams.customerContactName"
						style="width: 200px"
						:placeholder="$t('customerList.contactPerson')"
						:maxLength="50"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('customerList.contactPerson') }],
							},
						]"
					>
					</a-input>
				</a-form-item>
				<a-form-item :label="$t('businessDispatch.contactNumber')">
					<a-input
						allowClear
						v-model.trim="addReqParams.customerContactPhone"
						style="width: 200px"
						:placeholder="$t('businessDispatch.contactNumber')"
						:maxLength="50"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('businessDispatch.contactNumber') }],
							},
						]"
					>
					</a-input>
				</a-form-item>
			</a-form>
			<template slot="footer" v-if="isAdd">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading"
					@click="okdriver"
				>
					{{ $t('sure') }}
				</a-button>
				<a-button key="back" @click="resetdriver">
					{{ $t('reset') }}
				</a-button>
			</template>
			<template slot="footer" v-if="!isAdd">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading"
					@click="okdriver"
				>
					{{ $t('update') }}
				</a-button>
				<a-button key="back" @click="resetdriver">
					{{ $t('reset') }}
				</a-button>
			</template>
		</a-modal>

		<!-- table展示 -->
		<div class="table-area">
			<div style="height:75%;">
				<table-fixed
					:tableData="tableData"
					:tableColumn="columns"
					:columnSettingsKey="$route.name"
					:pagination="pagination"
					:loading="loading"
				>
					<template v-slot:toolbar>
						<a-button type="primary" size="small" @click="showBox">
							{{ $t('customerList.addCustomerInfo') }}
						</a-button>
					</template>
					<template v-slot:option="scope">
						<a-button
							v-if="scope.driver.name != '上海鸭嘴兽供应链管理有限公司'"
							@click="showUpdate(scope.driver)"
							>{{ $t('edit') }}</a-button
						>
					</template>
				</table-fixed>
			</div>
		</div>
	</div>
</template>
<script>
import tableFixed from "../../components/table-fixed.vue";
import {
	customerlist,
	addCustomerInfo,
	updateCustomerInfo,
} from "../../api/basicData";
import { columns } from "./customer-list";
import { searchReqParam } from "../../utils/searchReqParam";

let initReqParams = {
	currentUserCompanyId: "",
	currentUserId: "",
	customerContactName: "",
	customerContactPhone: "",
	address: "",
	name: "",
};
export default {
	name: "business-dispatch",
	components: { tableFixed },
	data() {
		return {
			columns,
			req: searchReqParam(),
			tableData: [],
			params: {
				condition: {
					address: "",
					companyId: "",
					customerContactName: "",
					customerContactPhone: "",
					customerId: "",
					customerType: "",
					name: "",
				},
				page: 1,
				pageSize: 10,
			},
			loading: false,
			pagination: {
				showSizeChanger: true,
				defaultPageSize: 10,
				pageSizeOptions: ["10", "15", "50", "100"],
				total: 0,
				current: 1,
				showTotal: (total) => this.$t('totalText', { total }),
				onChange: (page) => {
					this.pagination.current = page;
					this.req.params.page = page;
					this.pageInit();
				},
				onShowSizeChange: (current, pageSize) => {
					this.pagination.current = 1;
					this.req.params.page = 1;
					this.req.params.pageSize = pageSize;
					this.pageInit();
				},
			},
			dataSourceName: [],
			dataSourceAddress: [],
			dataSourceContactName: [],
			dataSourceContactPhone: [],
			isAdd: false,
			visible_formModal: false,
			confirmLoading: false,
			initReqParams,
			addReqParams: {},
		};
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		pageInit() {
			this.req.params = this.params;
			this.loading = true;
			// 用户信息列表
			customerlist(this.req).then((res) => {
				let resData = JSON.parse(res.data);
				if (!resData.success || resData.code != "0") {
					this.$message.error(resData.msg);
					return;
				}
				this.tableData = resData.data.list;
				this.pagination.total = resData.data.total;
				this.loading = false;
			});
		},
		// 搜索
		search() {
			this.pagination.onChange(1);
		},
		// 重置搜索
		resetCustomerList() {
			this.params.condition = {};
		},
		// 点击新增工厂信息按钮弹框
		showBox() {
			this.isAdd = true;
			// 新增时的初始化数据
			this.addReqParams = JSON.parse(JSON.stringify(this.initReqParams));
			this.visible_formModal = true;
		},
		// 点击编辑按钮
		showUpdate(driver) {
			console.log(driver);
			this.isAdd = false;
			this.initReqParams = {
				currentUserCompanyId: "",
				currentUserId: "",
				customerId: driver.customerId,
				customerContactName: driver.customerContactName,
				customerContactPhone: driver.customerContactPhone,
				name: driver.name,
				address: driver.address,
			};
			this.addReqParams = JSON.parse(JSON.stringify(this.initReqParams));
			this.visible_formModal = true;
		},
		// 取消 新增 / 更新
		canceldriverform() {
			this.visible_formModal = false;
			this.confirmLoading = false;
			this.initReqParams = {};
		},

		okdriver() {
			if (this.addReqParams.name == "" || this.addReqParams.name == undefined) {
				this.$message.error(this.$t('customerList.customerNameCannotBeEmpty'));
				return;
			}
			if (
				this.addReqParams.address == "" ||
				this.addReqParams.address == undefined
			) {
				this.$message.error(this.$t('customerList.addressCannotBeEmpty'));
				return;
			}
			// if (
			// 	this.addReqParams.customerContactName == "" ||
			// 	this.addReqParams.customerContactName == undefined
			// ) {
			// 	this.$message.error("联系人不能为空");
			// 	return;
			// }
			// if (
			// 	this.addReqParams.customerContactPhone == "" ||
			// 	this.addReqParams.customerContactPhone == undefined
			// ) {
			// 	this.$message.error("手机号不能为空");
			// 	return;
			// }
			// if (this.addReqParams.customerContactPhone.length < 11) {
			// 	this.$message.error("请输入11位手机号");
			// 	return;
			// }

			this.req.params = this.addReqParams;

			// 新增
			if (this.isAdd) {
				addCustomerInfo(this.req).then((res) => {
					let result = JSON.parse(res.data);
					this.resolveResData(result);
				});
				return;
			}
			// 更新
			updateCustomerInfo(this.req).then((res) => {
				let result = JSON.parse(res.data);
				this.resolveResData(result);
			});
		},

		// 新增 / 更新 接口返回数据处理
		resolveResData(result) {
			if (!result.success || result.code != 0) {
				this.$message.error(result.msg);
				return;
			}
			if (result.success && result.code == "0") {
				// 成功提示信息
				this.$message.success(result.msg);
				// 关闭新增窗口
				// this.visible_formModal = false;
				this.canceldriverform();
				// 刷新列表数据
				this.pageInit();
			}
		},
		// 重置
		resetdriver() {
			// 重置表单的数据为初始化数据 -- 两个不同的对象，数据独立
			this.addReqParams = JSON.parse(JSON.stringify(this.initReqParams));
		},

		// 搜索框模糊查询
		onChangeDataSource(searchText) {
			customerlist(this.req).then((res) => {
				let temp = JSON.parse(res.data).data.list;

				// 客户名称
				this.dataSourceName = [];
				temp.forEach((item) => {
					if (this.dataSourceName.indexOf(item.name) == -1) {
						this.dataSourceName.push(item.name);
					}
				});
				this.dataSourceName = !searchText ? [] : this.dataSourceName;

				// 地址
				this.dataSourceAddress = [];
				temp.forEach((item) => {
					if (this.dataSourceAddress.indexOf(item.address) == -1) {
						this.dataSourceAddress.push(item.address);
					}
				});
				this.dataSourceAddress = !searchText ? [] : this.dataSourceAddress;

				// 联系人姓名
				this.dataSourceContactName = [];
				temp.forEach((item) => {
					if (
						this.dataSourceContactName.indexOf(item.customerContactName) == -1
					) {
						this.dataSourceContactName.push(item.customerContactName);
					}
				});
				this.dataSourceContactName = !searchText
					? []
					: this.dataSourceContactName;

				// 联系人电话
				this.dataSourceContactPhone = [];
				temp.forEach((item) => {
					if (
						this.dataSourceContactPhone.indexOf(item.customerContactPhone) == -1
					) {
						this.dataSourceContactPhone.push(item.customerContactPhone);
					}
				});
				this.dataSourceContactPhone = !searchText
					? []
					: this.dataSourceContactPhone;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.location-textarea {
	::-webkit-scrollbar {
		width: 0px;
		height: 8px;
	}
}
</style>
